module.exports = __webpack_public_path__ + "images/interview-LinkedIn-2.svg";